module.exports = __webpack_public_path__ + "static/media/logo_polis_kasko.fa0329d4.svg";